import { FunctionComponent, useEffect, useState } from 'react';
import { getImageURLByIdFromProxy } from '../../services/content/image/Image';

import S365Picture from './S365Picture';

type Props = {
    id: string | null | undefined;
};
export const ImageAsync: FunctionComponent<Props> = ({ id }) => {
    const [imageUrl, setImageUrl] = useState('/placeholder_main_image.png');

    useEffect(() => {
        if (id) {
            getImageURLByIdFromProxy(id).then((image) => {
                image += '?operations=autocrop(120:50)';
                setImageUrl(image);
            });
        }
    }, [id]);

    return <S365Picture url={imageUrl} alt={''} isPriority={false} className='normalize-nextjs-image' />;
};
